import "./sidenav.scss";
import { memo, useContext } from "react";
import { OBScreensContext } from "../../contexts/OBScreensContext";
import { Link, useLocation } from "react-router-dom";

const MENU_ITEMS = [
    {
        id: "dashboard",
        label: "Dashboard",
        icon: "fa-dashboard",
        path: "/dashboard",
    },
    {
        id: "documentation",
        label: "Documentation",
        icon: "fa-book",
        path: "/documentation",
    },
    {
        id: "api-testing",
        label: "API Testing",
        icon: "fa-code",
        path: "/api-testing",
    },
    {
        id: "notifications",
        label: "Notifications",
        icon: "fa-bell",
        path: "/notifications",
    },
    {
        id: "profile",
        label: "Profile",
        icon: "fa-user",
        path: "/profile",
    },
];

const SideNav = ({ isOpen }) => {
    const { isOBScreen } = useContext(OBScreensContext);
    const location = useLocation();

    const isActive = (path) => {
        return location.pathname === path;
    };

    return (
        <aside className={isOpen ? "sidebar open" : "sidebar"}>
            <div className="top-sidebar">
                <ul className="sidebar-list">
                    {isOBScreen ? (
                        <>
                            <li className="inactive-logos" />
                            <li className="inactive-logos" />
                            <li className="inactive-logos" />
                            <li className="inactive-logos" />
                            <li className="inactive-logos" />
                        </>
                    ) : (
                        MENU_ITEMS.map((item) => (
                            <li
                                key={item.id}
                                className={`sidebar-item ${
                                    isActive(item.path) ? "active" : ""
                                }`}
                            >
                                <Link to={item.path} className="sidebar-link">
                                    <i className={`fa ${item.icon}`} />
                                    <span className="sidebar-label">
                                        {item.label}
                                    </span>
                                </Link>
                            </li>
                        ))
                    )}
                </ul>
            </div>

            <div className="bottom-sidebar">
                <ul className="sidebar-list">
                    <li className="sidebar-item">
                        <Link to="/settings" className="sidebar-link">
                            <i className="fa fa-cog" />
                            <span className="sidebar-label">Settings</span>
                        </Link>
                    </li>
                </ul>
            </div>
        </aside>
    );
};

export default memo(SideNav);
